import { makeStyles } from '@material-ui/styles';

import { Text, SadCat, MainButton } from '@bizzabo/design-system';

import InfoModal from '../InfoModal';

const ErrorPage = ({ resetErrorBoundary }) => {
    const classes = useStyles();

    const onClose = () => {
        resetErrorBoundary();
    };

    return (
        <InfoModal isOpen={true}>
            <div className={classes.modal}>
                <SadCat />
                <Text variant="t40" className={classes.title}>
                    Something went wrong
                </Text>
                <Text variant="t61">please try again in a few minutes</Text>
                <MainButton className={classes.closeBtn} onClick={onClose}>
                    Close
                </MainButton>
            </div>
        </InfoModal>
    );
};

const useStyles = makeStyles(
    theme => ({
        modal: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',

            [theme.breakpoints.up('sm')]: {
                maxHeight: 300,
            },
        },
        title: {
            margin: '10px 0',
        },
        closeBtn: {
            ...theme.typography.t80,
            height: '24px',
            marginTop: 20,
        },
    }),
    { classNamePrefix: 'video-error-page' }
);

export default ErrorPage;
